import { login, logout, getInfo } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {}
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password })
        .then(res => {
          const { token, userInfo } = res.data
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', userInfo)
          setToken(token)
          resolve()
        })
        .catch(reject)
    })
  },

  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(res => {
          const data = res.data
          commit('SET_USER_INFO', {
            id: data.id,
            username: data.username,
            nickname: data.nickname,
            avatar: data.avatar
          })
          resolve(data)
        })
        .catch(reject)
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {})
          removeToken()
          resolve()
        })
        .catch(error => {
          commit('SET_TOKEN', '')
          removeToken()
          reject(error)
        })
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      removeToken()
      resolve()
    })
  }
}

export default { namespaced: true, state, mutations, actions }
